export default __webpack_public_path__ + "static/media/Experience Selector.494df463.svg";